import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, ReportUIRenderer, ReportUIRendererProps } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import RicosCriteria from "./RicosCriteria";
import { ComponentType } from "react";
import { AppService, Types } from "../../../App/Services/AppService";
import { FileUtils } from "@singularsystems/neo-core";

@NeoReport("RicosExport", { category: ReportCategory.Exports })
export default class RicosReport extends Report<RicosCriteria> {

    constructor() {
        super(RicosCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.runDate} />
            </Neo.GridLayout>
        </div>;
    }

    get uiRenderer(): ComponentType<ReportUIRendererProps> {
        return RicosReportUIRenderer;
    }
}

class RicosReportUIRenderer extends ReportUIRenderer {
    
    renderActionButtons(): React.ReactNode {
        
        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file"
                variant="secondary"
                onClick={() => this.downloadFile()}>
                    Download File
            </Neo.Button>
        </>
    }

    private async downloadFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getRicosFile((this.report as RicosReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }
}